const daanregency=[
    
{
      src: 'https://daanregency.com/uploads/5d0fda4f-9bd7-4138-acaa-9ad4507754571.jpg',
      alt: 'Daan Regency ',
    },
    {
      src: 'https://daanregency.com/uploads/51318865-f1b7-4732-be95-ce0b5c2571ff1.jpg',
 alt: 'Daan Regency ',
    },
    {
      src: 'https://daanregency.com/uploads/WhatsApp_Image_2022-06-13_at_11_03_13_AM_(1)1.jpeg',
alt: 'Daan Regency ',   },
    {
      src: 'https://daanregency.com/uploads/WhatsApp_Image_2022-06-13_at_11_03_13_AM_(1)1.jpeg',
alt: 'Daan Regency ',    },
    {
      src: 'https://daanregency.com/uploads/WhatsApp_Image_2022-06-13_at_11_03_14_AM.jpeg',
alt: 'Daan Regency ',   }, {
      src: 'https://daanregency.com/uploads/dc25ee60-a4f2-4d94-ac93-c9c372b4d31d.jpg',
   alt: 'Daan Regency ',
    }, 

]

export default daanregency;